import React from 'react';
import { ReaderPathCheck } from '../ReaderPathCheck';
interface QuickCheckProps {
  questionId: string;
  checkLabel?: string;
  confirmationText?: string;
}

/**
 * Light band wrapper for an inline ReaderPathCheck. Reuses the existing
 * component, question IDs, and scoring untouched.
 */
export function QuickCheck(props: QuickCheckProps) {
  return <section className="bg-paper px-6 py-10 md:py-12" data-id="element-911" data-mp="3n3bm2rcd17bk">
      <div className="mx-auto max-w-3xl md:max-w-4xl" data-id="element-912" data-mp="oo0yrxvhgop3">
        <ReaderPathCheck {...props} compact data-id="element-913" data-mp="olep9sp17z48" />
      </div>
    </section>;
}